/**
 * Decode a JWT token payload without signature verification.
 * Safe for client-side use — we only decode data from a token we just received.
 * @param {string} token - JWT string (header.payload.signature)
 * @returns {Object|null} decoded payload or null on failure
 */
export const decodeJwt = (token) => {
  try {
    const base64Payload = token.split(".")[1];
    const padded = base64Payload.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(padded)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("JWT decode failed:", e);
    return null;
  }
};
